// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"kf_a pz_b pz_qp","TwoDimsListFeature__item":"kf_b pz_ro","TwoDimsListFeature__item__text":"kf_c pz_rf"};